import { forwardRef } from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

const PrintableClientReport = forwardRef(({ account, entries, formatCurrency }, ref) => {
  const totalAmount = entries?.reduce((sum, entry) => sum + entry.amount, 0) || 0;
  const totalCollection = entries?.reduce((sum, entry) => sum + entry.collection, 0) || 0;
  const totalBalance = entries?.reduce((sum, entry) => sum + entry.balance, 0) || 0;

  return (
    <Box ref={ref} sx={{ p: 4, bgcolor: 'white' }}>
      <Typography variant="h4" sx={{ mb: 2 }}>Client Report</Typography>
      
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6">{account?.name}</Typography>
        <Typography>Department: {account?.department}</Typography>
        <Typography>Address: {account?.address}</Typography>
        <Typography>Contact: {account?.contactNo}</Typography>
        <Typography sx={{ mt: 2 }}>
          Date Generated: {new Date().toLocaleDateString()}
        </Typography>
      </Box>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell>DR/SI No</TableCell>
            <TableCell align="right">Amount</TableCell>
            <TableCell>Collection Receipts</TableCell>
            <TableCell align="right">Balance</TableCell>
            <TableCell>Comments</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {entries?.map((entry) => (
            <TableRow key={entry.id}>
              <TableCell>{entry.date}</TableCell>
              <TableCell>{entry.drNumber}</TableCell>
              <TableCell align="right">{formatCurrency(entry.amount)}</TableCell>
              <TableCell>
                {entry.collection_receipts?.map((receipt, index) => (
                  <Typography key={receipt.id} variant="body2">
                    {receipt.receipt_number} ({formatCurrency(receipt.amount)})
                    {index < entry.collection_receipts.length - 1 ? ', ' : ''}
                  </Typography>
                ))}
              </TableCell>
              <TableCell align="right">{formatCurrency(entry.balance)}</TableCell>
              <TableCell>{entry.comments}</TableCell>
              <TableCell>{entry.balance <= 0 ? 'Fully Paid' : 'Pending'}</TableCell>
            </TableRow>
          ))}
          <TableRow>
            <TableCell colSpan={2} sx={{ fontWeight: 'bold' }}>Total</TableCell>
            <TableCell align="right" sx={{ fontWeight: 'bold' }}>{formatCurrency(totalAmount)}</TableCell>
            <TableCell align="right" sx={{ fontWeight: 'bold' }}>{formatCurrency(totalCollection)}</TableCell>
            <TableCell align="right" sx={{ fontWeight: 'bold' }}>{formatCurrency(totalBalance)}</TableCell>
            <TableCell colSpan={2} />
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  );
});

export default PrintableClientReport; 